import { useState } from 'react';

const Accordions = (losesAccess) => {
  const [openAcc, setOpenAcc] = useState({
    general: false,
    profesional: false,
    academica: false,
    interes: false,
    credenciales: false,
  });

  const toggleAcc = async (key) => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setOpenAcc((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return {
    openAcc,
    toggleAcc,
  };
};

export default Accordions;
